// src/components/Modal/LimitExceededModal.tsx
import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useLimitExceeded } from '../../context/LimitExceededContext';

const LimitExceededModal: React.FC = () => {
  const navigate = useNavigate();
  const { isModalOpen, modalMessage, closeLimitModal } = useLimitExceeded();

  if (!isModalOpen) return null;

  const handleUpgradeClick = () => {
    closeLimitModal();
    navigate('/pricing'); // Adjust this path to your actual pricing page route
  };

  const modalContent = (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onClick={closeLimitModal}
    >
      <div 
        style={{
          backgroundColor: '#2d2d2d',
          padding: '32px',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            color: '#e0e0e0',
            cursor: 'pointer',
            padding: '4px 8px'
          }}
          onClick={closeLimitModal}
        >
          ×
        </button>
        
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            fontSize: '48px', 
            marginBottom: '16px',
            lineHeight: 1
          }}>
            ⚠️
          </div>
          <h2 style={{ 
            margin: '0 0 16px 0', 
            color: '#e0e0e0', 
            fontSize: '22px',
            fontWeight: 600
          }}>
            Limit Exceeded
          </h2>
          <p style={{ 
            margin: '0', 
            color: '#ddd', 
            fontSize: '15px', 
            lineHeight: '1.6'
          }}>
            {modalMessage}
          </p>
        </div>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '12px',
          marginTop: '24px'
        }}>
          <button 
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #555',
              color: '#e0e0e0',
              padding: '10px 20px',
              fontSize: '14px',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '100px'
            }}
            onClick={closeLimitModal}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#333';
              e.currentTarget.style.borderColor = '#888';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = '#555';
            }}
          >
            Cancel
          </button>
          
          <button 
            style={{
              backgroundColor: '#2196f3',
              border: '1px solid #2196f3',
              color: '#ffffff',
              padding: '10px 20px',
              fontSize: '14px',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              fontWeight: 500
            }}
            onClick={handleUpgradeClick}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#1976d2';
              e.currentTarget.style.borderColor = '#1976d2';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2196f3';
              e.currentTarget.style.borderColor = '#2196f3';
            }}
          >
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LimitExceededModal;
